/**
 * @generated SignedSource<<9955f48d4d2dac09f8ade4d0273e6282>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type addDestinationToModelMutation$variables = {
  destinationName: string;
  modelName: string;
};
export type addDestinationToModelMutation$data = {
  readonly addDestinationToModel: {
    readonly displayName: string | null;
    readonly name: string;
  };
};
export type addDestinationToModelMutation = {
  response: addDestinationToModelMutation$data;
  variables: addDestinationToModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "destinationName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "destinationName",
        "variableName": "destinationName"
      },
      {
        "kind": "Variable",
        "name": "modelName",
        "variableName": "modelName"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "addDestinationToModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addDestinationToModelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addDestinationToModelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbaa8513d53eb4bd242c1d6ac5bd1682",
    "id": null,
    "metadata": {},
    "name": "addDestinationToModelMutation",
    "operationKind": "mutation",
    "text": "mutation addDestinationToModelMutation(\n  $destinationName: String!\n  $modelName: String!\n) {\n  addDestinationToModel(destinationName: $destinationName, modelName: $modelName) {\n    displayName\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "d01893b580c33265e9bed3228c9e6506";

export default node;
